import { useEffect } from "react";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

/**
 * Loads gtag.js for Google Analytics 4 once on app mount.
 * No-op if REACT_APP_GA_MEASUREMENT_ID isn't set.
 * Set the variable in frontend/.env (e.g. REACT_APP_GA_MEASUREMENT_ID=G-XXXXXXXXXX)
 * and restart frontend.
 */
export default function GoogleAnalytics() {
  useEffect(() => {
    if (!GA_ID || document.getElementById("ga-script")) return;
    const s1 = document.createElement("script");
    s1.id = "ga-script";
    s1.async = true;
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s1);

    const s2 = document.createElement("script");
    s2.id = "ga-init";
    s2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', '${GA_ID}', { anonymize_ip: true });
    `;
    document.head.appendChild(s2);
  }, []);
  return null;
}
